import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3bb18828"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "graph" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { style: { "display": "flex", "justify-content": "space-between", "align-items": "center" } };
const _hoisted_4 = { class: "assetRange" };
const _hoisted_5 = { class: "chartArea" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("canvas", { id: "assets-chart" }, null, -1));
const _hoisted_7 = [
    _hoisted_6
];
import { computed } from 'vue';
import { useStore } from '@/store/store';
import Select from '@/materials/atoms/Select.vue';
import NoData from '@/materials/atoms/NoData.vue';
import Loading from '@/materials/molecules/Loading.vue';
import { useAssetsChart } from '@/logics/assets_chart';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const store = useStore();
        const { isLoading, selectedSymbol, assetsRange } = useAssetsChart();
        const currencies = computed(() => store.state.currencyInfo.map((m) => ({ title: m.currencyName, value: m.symbol.toLocaleLowerCase() })));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(NoData, {
                        "is-show": _unref(store).state.balances.length === 0
                    }, null, 8, ["is-show"]),
                    (_unref(store).state.balances.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["assetRange_p1", _unref(assetsRange) === 7 || 'negative']),
                                        onClick: _cache[0] || (_cache[0] = ($event) => (assetsRange.value = 7))
                                    }, "7 days", 2),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["assetRange_p1", _unref(assetsRange) === 30 || 'negative']),
                                        onClick: _cache[1] || (_cache[1] = ($event) => (assetsRange.value = 30))
                                    }, "30 days", 2)
                                ]),
                                _createElementVNode("div", null, [
                                    (!!_unref(selectedSymbol))
                                        ? (_openBlock(), _createBlock(Select, {
                                            key: 0,
                                            model: _unref(selectedSymbol),
                                            selectionList: _unref(currencies),
                                            width: 150,
                                            onChange: _cache[2] || (_cache[2] = (value) => (selectedSymbol.value = value))
                                        }, null, 8, ["model", "selectionList"]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _withDirectives(_createElementVNode("div", null, [
                                _createVNode(Loading, { mode: "sound" })
                            ], 512), [
                                [_vShow, _unref(isLoading)]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_7, 512), [
                                [_vShow, !_unref(isLoading)]
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
